<template>
  <div class="role-container">
    <v-flex xs12>
      <ams-breadcrumb :BreadItem="items"></ams-breadcrumb>
    </v-flex>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-list subheader>
        <v-subheader> 角色信息 </v-subheader>
        <v-flex md-6 text-md-left class="mx-4">
          <v-text-field :validate-on-blur="true" v-model="rolename" maxlength="20" :counter="20" :rules="roleRules"
            @change="changeRoleName" @blur="checkRoleName($event.target.value)" label="角色名称" placeholder="请输入角色名称"
            required></v-text-field>
          <span v-if="exsitRoleName" style="color:red;">角色名称已经存在</span>
        </v-flex>
        <v-flex md-6 text-md-left class="mx-4">
          <v-textarea name="remark" label="角色描述" v-model="remark" clearable hint="请输入，少于50个字符" maxlength="50"
            :counter="50"></v-textarea>
        </v-flex>
      </v-list>
      <v-divider></v-divider>

      <v-list>
        <v-subheader> 权限设置 </v-subheader>
        <v-flex md-6 text-md-left class="mx-4">
          <v-checkbox :indeterminate="indeterminateAll" v-model="selectAll" hide-details label="全选"
            @change="(selected) => handleSelect({ all: true, selected })"></v-checkbox>
          <v-data-table :items="permList" class="elevation-1 border-t-grey perm-table" hide-actions hide-headers>
            <template v-slot:items="{ item, index }">
              <td v-for="value in item" :key="value.value" :rowspan="value.span" class="text-xs-left border-l-grey">
                <v-checkbox v-if="value.value" hide-details v-model="value.has" :indeterminate="value.indeterminate"
                  :label="value.text"
                  @change="val => handleSelect({rowIdx: index, colIdx: value.index, selected: val})">
                </v-checkbox>
              </td>
              <td class="text-xs-left border-l-grey" v-if="!item[colNum-1]"></td>
            </template>
          </v-data-table>
        </v-flex>
      </v-list>

      <v-flex md-6 text-md-center class="mx-4">
        <v-btn @click="$router.go(-1)">返回</v-btn>
        <v-btn color="primary" :disabled="!valid || exsitRoleName" :loading="addloading"
          v-clickthrottle="{ handle: save, delay: 4000 }">保存</v-btn>
      </v-flex>
    </v-form>
  </div>
</template>

<script>
  import request from '@/utils/request';
  import { AppStore } from '@/store/modules/app';
  import TreeSelect from '@/libs/treeSelect';
  import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
  import { emptyRule, selectListEmptyRule, phoneRule, telRule } from '@/utils/rules';
  export default {
    components: {
      'ams-breadcrumb': AMSBreadcrumb
    },
    data: () => ({
      valid: true,
      rolename: '',
      remark: '',
      roleRules: [emptyRule('角色名称')],
      items: [],
      permList: [],
      selected_perm: [],
      selectAll: false,
      indeterminateAll: false,
      colNum: 0,
      type: '',
      roleId: '',
      exsitRoleName: false,
      addloading: false
    }),
    methods: {
      changeRoleName(value) {
        value = value.replace(/\s+/g, '');
        this.rolename = value;
      },
      checkRoleName(value) {
        request.get(`/api/Setting/Role/CheckHasName`, { name: value.replace(/\s+/g, ''), ignoreId: this.roleId }).then(data => {
          if (data) {
            this.exsitRoleName = true;
          } else {
            this.exsitRoleName = false;
          }
        });
      },
      save() {
        if (this.$refs.form.validate() && !this.exsitRoleName) {
          this.addloading = true;
          let formData = {
            role: this.type
              ? {
                displayName: this.rolename,
                remark: this.remark,
                id: this.roleId
              }
              : { displayName: this.rolename, remark: this.remark },
            grantedPermissionNames: this.selected_perm
          };
          request
            .post('/api/Setting/Role/CreateOrEdit', formData)
            .then(data => {
              this.addloading = false;
              AppStore.ShowSuccess('保存成功！');
              this.$router.push('/rolePermission');
            })
            .catch(error => {
              this.addloading = false;
              AppStore.ShowError(`保存失败！${error.response.data.error.message}`);
            });
        }
      },
      getPermission(id) {
        request.get(`/api/Setting/Role/QueryRoleById`, { id }).then(res => {
          this.treeSelect = new TreeSelect(res.permissions, 1);
          this.permList = this.treeSelect.tableData;
          this.selected_perm = this.treeSelect.selectedData;
          this.colNum = this.treeSelect.colNum;
          this.selectAll = this.treeSelect.selectAll;
          this.indeterminateAll = this.treeSelect.globalIndeterminate;
          this.rolename = res.displayName;
          this.remark = res.remark;
        });
      },
      handleSelect(option) {
        if (option.all) {
          this.treeSelect.toggleAll(option.selected);
        } else {
          this.treeSelect.handleChange(option);
          this.selectAll = this.treeSelect.selectAll;
        }
        this.permList = this.treeSelect.tableData;
        this.selected_perm = this.treeSelect.selectedData;
        this.indeterminateAll = this.treeSelect.globalIndeterminate;
      }
    },
    mounted() {
      this.type = this.$route.query.type;
      this.roleId = this.$route.query.id;
      this.items = [
        {
          text: '系统设置',
          disabled: false
        },
        {
          text: '角色权限',
          disabled: false,
          href: '/rolePermission'
        },
        {
          text: this.type ? '修改角色' : '新增角色',
          disabled: true
        }
      ];

      this.getPermission(this.roleId || '');
    }
  };
</script>

<style lang='stylus' scoped>
  .border-l-grey:not(:first-child) {
    border-left: 1px solid rgba(0, 0, 0, 0.12);
  }

  .border-t-grey {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
  .perm-table {
    table.v-table tbody td:last-child, table.v-table tbody td:not(:first-child) {
      padding: 0 24px !important;
    }
  }
</style>